module.exports = __webpack_public_path__ + "img/25.2.TN.6eb4ba57.png";